import React from "react";

const items = [
  "Vanguard Water Systems",
  "Protect What Matters",
  "Perfecting Water",
  "Vanguard Water Systems",
  "Protecting Life",
  "Northern Utah",
  "Kinetico Dealer",
  "Southern Idaho",
  "Non-Electric",
  "Twin-Tank",
];

export default function Marquee() {
  return (
    <section
      className="relative py-14 lg:py-20 border-y border-[color:var(--border)] overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="marquee">
        <div className="marquee-track">
          {[...items, ...items].map((t, i) => (
            <span
              key={i}
              className="font-editorial italic text-[clamp(3rem,7vw,7.5rem)] font-normal leading-none text-white/90"
            >
              {t}
              <span className="mx-16 text-[color:var(--blue)]">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
